export const fieldName = {
  amenity: {
    single: 'amenity',
    multiple: 'amenities',
    foreignKey: 'amenityId',
    capitalLetter: 'Amenity',
  },
  category: {
    single: 'category',
    multiple: 'categories',
    foreignKey: 'categoryId',
    capitalLetter: 'Category',
  },
  location: {
    single: 'location',
    multiple: 'locations',
    foreignKey: 'locationId',
    capitalLetter: 'Location',
  },
  part: {
    single: 'part',
    multiple: 'parts',
    foreignKey: 'partId',
    capitalLetter: 'Part',
  },
};
